import React, { Component } from 'react'
import { connect } from 'react-redux'
import { _DOTNET, _JAVA, _PHP } from '../../../actions/types'

class ResCavvPurchaseSample extends Component {
    getOrderId() {
        const { order_id, selectedProgLangId } = this.props;
        if(order_id === "none") {
            switch(selectedProgLangId) {
                case _DOTNET:
                    return `"Test" + DateTime.Now.ToString("yyyyMMddhhmmss")`;
                case _JAVA:
                    return `"Test"+createDate.getTime()`;
                case _PHP:
                    return `'ord-'.date("dmy-G:i:s")`;
                default:
                    return "";
            }
        }
        else
            return `"${order_id}"`;
    }

    getValue(val, id) {
        return (
            <span className= {this.props.onEditId === id ? 'codeValue' : ''}>{val}</span>
        );
    }

    render() {
        const { storeId, apiToken, expdate, amount, cavv, eci, selectedProgLangId } = this.props;

        switch(selectedProgLangId) {
            case _DOTNET:
                return (
                    <pre className="sampleCode">
{`namespace Moneris
{ 
 using System;
 using System.Text;
 using System.Collections;
 public class TestCanadaResCavvPurchaseCC
 { 
  public static void Main(string[] args)
  { 
   string store_id = "`}{this.getValue(storeId, "storeId")}{`";
   string api_token = "`}{this.getValue(apiToken, "apiToken")}{`";
   string data_key = "4INQR1A8ocxD0oafSz50LADXy";
   string order_id = ${this.getOrderId()};
   string amount = "`}{this.getValue(amount, "amount")}{`";
   string cust_id = "customer1"; //if sent will be submitted, otherwise cust_id from profile
   will be used
   string expdate = "`}{this.getValue(expdate, "expdate")}{`"; //YYMM
   string cavv = "${cavv}";
   string processing_country_code = "CA";
   bool status_check = false;
   
   CofInfo cof = new CofInfo();
   
   cof.SetPaymentIndicator("U");
   cof.SetPaymentInformation("2");
   cof.SetIssuerId("168451306048014");
   
   ResCavvPurchaseCC resCavvPurchaseCC = new ResCavvPurchaseCC();
   
   resCavvPurchaseCC.SetOrderId(order_id);
   resCavvPurchaseCC.SetDataKey(data_key);
   resCavvPurchaseCC.SetCustId(cust_id);
   resCavvPurchaseCC.SetAmount(amount);
   resCavvPurchaseCC.SetCavv(cavv);
   resCavvPurchaseCC.SetExpDate(expdate);
   resCavvPurchaseCC.SetThreeDSVersion("2"); //Mandatory for 3DS Version 2.0+
   resCavvPurchaseCC.SetThreeDSServerTransId("e11d4985-8d25-40ed-99d6-c3803fe5e68f"); //Mandatory for 3DS 
   Version 2.0+ - obtained from MpiCavvLookup or MpiThreeDSAuthentication
   
   //resCavvPreauthCC.SetDsTransId("12345"); //Optional - to be used only if you are using 3rd
   party 3ds 2.0 service
   
   resCavvPurchaseCC.SetCofInfo(cof);

   HttpsPostRequest mpgReq = new HttpsPostRequest();
   mpgReq.SetProcCountryCode(processing_country_code);
   mpgReq.SetTestMode(true); //false or comment out this line for production transactions
   mpgReq.SetStoreId(store_id);
   mpgReq.SetApiToken(api_token);
   mpgReq.SetTransaction(resCavvPurchaseCC);
   mpgReq.SetStatusCheck(status_check);
   mpgReq.Send();
   
   try
   { 
    Receipt receipt = mpgReq.GetReceipt();
    
    Console.WriteLine("DataKey = " + receipt.GetDataKey());
    Console.WriteLine("ReceiptId = " + receipt.GetReceiptId());
    Console.WriteLine("ReferenceNum = " + receipt.GetReferenceNum());
    Console.WriteLine("ResponseCode = " + receipt.GetResponseCode());
    Console.WriteLine("AuthCode = " + receipt.GetAuthCode());
    Console.WriteLine("Message = " + receipt.GetMessage());
    Console.WriteLine("TransDate = " + receipt.GetTransDate());
    Console.WriteLine("TransTime = " + receipt.GetTransTime());
    Console.WriteLine("TransType = " + receipt.GetTransType());
    Console.WriteLine("Complete = " + receipt.GetComplete());
    Console.WriteLine("TransAmount = " + receipt.GetTransAmount());
    Console.WriteLine("CardType = " + receipt.GetCardType());
    Console.WriteLine("TxnNumber = " + receipt.GetTxnNumber());
    Console.WriteLine("TimedOut = " + receipt.GetTimedOut());
    Console.WriteLine("ResSuccess = " + receipt.GetResSuccess());
    Console.WriteLine("PaymentType = " + receipt.GetPaymentType());
    Console.WriteLine("CavvResultCode = " + receipt.GetCavvResultCode());
    Console.WriteLine("IssuerId = " + receipt.GetIssuerId());
    Console.WriteLine("ThreeDSVersion = " + receipt.GetThreeDSVersion());

    //ResolveData
    Console.WriteLine("Cust ID = " + receipt.GetResDataCustId());
    Console.WriteLine("Phone = " + receipt.GetResDataPhone());
    Console.WriteLine("Email = " + receipt.GetResDataEmail());
    Console.WriteLine("Note = " + receipt.GetResDataNote());
    Console.WriteLine("Masked Pan = " + receipt.GetResDataMaskedPan());
    Console.WriteLine("Exp Date = " + receipt.GetResDataExpdate());
    Console.WriteLine("Crypt Type = " + receipt.GetResDataCryptType());
    Console.WriteLine("Avs Street Number = " + receipt.GetResDataAvsStreetNumber());
    Console.WriteLine("Avs Street Name = " + receipt.GetResDataAvsStreetName());
    Console.WriteLine("Avs Zipcode = " + receipt.GetResDataAvsZipcode());
   } 
   catch (Exception e)
   { 
    Console.WriteLine(e);
   }
  }
 }
}
`}
                </pre>)

        case _JAVA:
            return (
                <pre className="sampleCode">
{`package Canada;

import JavaAPI.*;

public class TestCanadaResCavvPurchaseCC
{ 
 public static void main(String[] args)
 { 
  String store_id = "`}{this.getValue(storeId, "storeId")}{`";
  String api_token = "`}{this.getValue(apiToken, "apiToken")}{`";
  String data_key = "4INQR1A8ocxD0oafSz50LADXy";
  java.util.Date createDate = new java.util.Date();
  String order_id = ${this.getOrderId()};
  String amount = "`}{this.getValue(amount, "amount")}{`";
  String cust_id = "customer1"; //if sent will be submitted, otherwise cust_id from profile will be used
  String cavv = "${cavv}";
  String processing_country_code = "CA";
  String exp_date = "`}{this.getValue(expdate, "expdate")}{`";
  boolean status_check = false;

  ResCavvPurchaseCC resCavvPurchaseCC = new ResCavvPurchaseCC();
  resCavvPurchaseCC.setOrderId(order_id);
  resCavvPurchaseCC.setDataKey(data_key);
  resCavvPurchaseCC.setCustId(cust_id);
  resCavvPurchaseCC.setAmount(amount);
  resCavvPurchaseCC.setCavv(cavv);
  resCavvPurchaseCC.setExpDate(exp_date);
  resCavvPurchaseCC.setThreeDSVersion("2"); //Mandatory for 3DS Version 2.0+
  resCavvPurchaseCC.setThreeDSServerTransId("e11d4985-8d25-40ed-99d6-c3803fe5e68f");

  //Mandatory for 3DS Version 2.0+ - obtained from MpiCavvLookup or MpiThreeDSAuthentication
  //resCavvPurchaseCC.setDsTransId("12345");//Optional - to be used only if you are using 3rd
  party 3ds 2.0 service

  //Mandatory - Credential on File details
  CofInfo cof = new CofInfo();
  cof.setPaymentIndicator("U");
  cof.setPaymentInformation("2");
  cof.setIssuerId("139X3130ASCXAS9");

  resCavvPurchaseCC.setCofInfo(cof);

  HttpsPostRequest mpgReq = new HttpsPostRequest();
  mpgReq.setProcCountryCode(processing_country_code);
  mpgReq.setTestMode(true); //false or comment out this line for production transactions
  mpgReq.setStoreId(store_id);
  mpgReq.setApiToken(api_token);
  mpgReq.setTransaction(resCavvPurchaseCC);
  mpgReq.setStatusCheck(status_check);
  mpgReq.send();
  
  try
  { 
    System.out.println("DataKey = " + receipt.getDataKey());
    System.out.println("ReceiptId = " + receipt.getReceiptId());
    System.out.println("ReferenceNum = " + receipt.getReferenceNum());
    System.out.println("ResponseCode = " + receipt.getResponseCode());
    System.out.println("AuthCode = " + receipt.getAuthCode());
    System.out.println("Message = " + receipt.getMessage());
    System.out.println("TransDate = " + receipt.getTransDate());
    System.out.println("TransTime = " + receipt.getTransTime());
    System.out.println("TransType = " + receipt.getTransType());
    System.out.println("Complete = " + receipt.getComplete());
    System.out.println("TransAmount = " + receipt.getTransAmount());
    System.out.println("CardType = " + receipt.getCardType());
    System.out.println("TxnNumber = " + receipt.getTxnNumber());
    System.out.println("TimedOut = " + receipt.getTimedOut());
    System.out.println("ResSuccess = " + receipt.getResSuccess());
    System.out.println("PaymentType = " + receipt.getPaymentType());
    System.out.println("CavvResultCode = " + receipt.getCavvResultCode());
    System.out.println("IssuerId = " + receipt.getIssuerId());
    System.out.println("ThreeDSVersion = " + receipt.getThreeDSVersion());

    //ResolveData
    System.out.println("Cust ID = " + receipt.getResCustId());
    System.out.println("Phone = " + receipt.getResPhone());
    System.out.println("Email = " + receipt.getResEmail());
    System.out.println("Note = " + receipt.getResNote());
    System.out.println("Masked Pan = " + receipt.getResMaskedPan());
    System.out.println("Exp Date = " + receipt.getResExpdate());
    System.out.println("Crypt Type = " + receipt.getResCryptType());
    System.out.println("Avs Street Number = " + receipt.getResAvsStreetNumber());
    System.out.println("Avs Street Name = " + receipt.getResAvsStreetName());
    System.out.println("Avs Zipcode = " + receipt.getResAvsZipcode());
  } 
  catch (Exception e)
  { 
   e.printStackTrace();
  }
 }
}
`}
                </pre>
            )

        case _PHP:
            return (
                <pre className="sampleCode">
{`<?php
require "../../mpgClasses.php";
/************************ Request Variables **********************************/
$store_id='`}{this.getValue(storeId, "storeId")}{`';
$api_token='`}{this.getValue(apiToken, "apiToken")}{`';
/************************ Transaction Variables ******************************/
$data_key='4INQR1A8ocxD0oafSz50LADXy';
$order_id=${this.getOrderId()};
$amount='`}{this.getValue(amount, "amount")}{`';
$cavv='${cavv}';
$custid='customer1'; //if sent will be submitted, otherwise cust_id from profile will be
used
$expdate = '`}{this.getValue(expdate, "expdate")}{`'; //YYMM - used only for temp token
//$crypt_type = '${eci}'; //value obtained from MpiACS transaction
/************************ Transaction Array **********************************/
$txnArray =array('type'=>'res_cavv_purchase_cc',
'data_key'=>$data_key,
'order_id'=>$orderid,
'cust_id'=>$custid,
'amount'=>$amount,
'cavv'=>$cavv,
'expdate'=>$expdate, //mandatory for temp tokens only
//'crypt_type'=>$crypt_type, //set for AMEX SafeKey only
//'dynamic_descriptor'=>'12346',
'threeds_version' => '2', //Mandatory for 3DS Version 2.0+
'threeds_server_trans_id' => 'e11d4985-8d25-40ed-99d6-c3803fe5e68f', //Mandatory for 3DS
Version 2.0+ - obtained from MpiCavvLookup or MpiThreeDSAuthentication
//'ds_trans_id' => '12345' //Optional - to be used only if you are using 3rd party 3ds 2.0
service
);
/************************ Transaction Object *******************************/
$mpgTxn = new mpgTransaction($txnArray);
/******************* Credential on File **********************************/
$cof = new CofInfo();
$cof->setPaymentIndicator("U");
$cof->setPaymentInformation("2");
$cof->setIssuerId("168451306048014");
$mpgTxn->setCofInfo($cof);
/************************ Request Object **********************************/
$mpgRequest = new mpgRequest($mpgTxn);
$mpgRequest->setProcCountryCode("CA"); //"US" for sending transaction to US environment
$mpgRequest->setTestMode(true); //false or comment out this line for production
transactions
/************************ mpgHttpsPost Object ******************************/
$mpgHttpPost = new mpgHttpsPost($store_id,$api_token,$mpgRequest);
/************************ Response Object **********************************/
$mpgResponse=$mpgHttpPost->getMpgResponse();
print("\\nDataKey = " . $mpgResponse->getDataKey());
print("\\nReceiptId = " . $mpgResponse->getReceiptId());
print("\\nReferenceNum = " . $mpgResponse->getReferenceNum());
print("\\nResponseCode = " . $mpgResponse->getResponseCode());
print("\\nISO = " . $mpgResponse->getISO());
print("\\nAuthCode = " . $mpgResponse->getAuthCode());
print("\\nMessage = " . $mpgResponse->getMessage());
print("\\nTransDate = " . $mpgResponse->getTransDate());
print("\\nTransTime = " . $mpgResponse->getTransTime());
print("\\nTransType = " . $mpgResponse->getTransType());
print("\\nComplete = " . $mpgResponse->getComplete());
print("\\nTransAmount = " . $mpgResponse->getTransAmount());
print("\\nCardType = " . $mpgResponse->getCardType());
print("\\nTxnNumber = " . $mpgResponse->getTxnNumber());
print("\\nTimedOut = " . $mpgResponse->getTimedOut());
print("\\nAVSResponse = " . $mpgResponse->getAvsResultCode());
print("\\nResSuccess = " . $mpgResponse->getResSuccess());
print("\\nPaymentType = " . $mpgResponse->getPaymentType());
print("\\nCavvResultCode = " . $mpgResponse->getCavvResultCode());
print("\\nIssuerId = " . $mpgResponse->getIssuerId());
print("\\nThreeDSVersion = " . $mpgResponse->getThreeDSVersion());
//----------------- ResolveData ------------------------------
print("\\n\\nCust ID = " . $mpgResponse->getResDataCustId());
print("\\nPhone = " . $mpgResponse->getResDataPhone());
print("\\nEmail = " . $mpgResponse->getResDataEmail());
print("\\nNote = " . $mpgResponse->getResDataNote());
print("\\nMasked Pan = " . $mpgResponse->getResDataMaskedPan());
print("\\nExp Date = " . $mpgResponse->getResDataExpDate());
print("\\nCrypt Type = " . $mpgResponse->getResDataCryptType());
print("\\nAvs Street Number = " . $mpgResponse->getResDataAvsStreetNumber());
print("\\nAvs Street Name = " . $mpgResponse->getResDataAvsStreetName());
print("\\nAvs Zipcode = " . $mpgResponse->getResDataAvsZipcode());
?>
`}
                </pre>
            )
        default:
            return null
        }
    }
}

const mapStateToProps = state => {
  const { storeId, apiToken, order_id, expdate, amount, cavv, eci, onEditId } = state.threeDSTwo.main.config;
  const { selection } = state.common.progLangList;
  return { storeId, apiToken, order_id, expdate, amount, cavv, eci, selectedProgLangId: selection, onEditId };
}

export default connect(mapStateToProps, {})(ResCavvPurchaseSample)
